function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewStory4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 659.9 748.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "overview-story4-outer"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "overview-story4-dottedCircle",
    cx: 334.8,
    cy: 440.2,
    r: 305.1,
    style: {
      fill: "none",
      stroke: "#a5a5a5",
      strokeDasharray: "0 0 24 24",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.3,741H6.8c-2.9,0-5.3-2.4-5.3-5.3v-133.5c0-2.9,2.4-5.3,5.3-5.3h133.5c2.9,0,5.3,2.4,5.3,5.3v133.5c0,2.9-2.4,5.3-5.3,5.3Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1,
    y1: 632.5,
    x2: 132.7,
    y2: 632.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.8,
    cy: 614.7,
    r: 8.4,
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.1,
    cy: 614.7,
    r: 8.4,
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4,718.3H20.4c-3.5,0-6.3-2.8-6.3-6.3v-62.4c0-3.5,2.8-6.3,6.3-6.3h106c3.5,0,6.3,2.8,6.3,6.3v62.4c0,3.5-2.8,6.3-6.3,6.3Z",
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M529.2,729c-2.4,0-4.4-2-4.4-4.4v-111.3h132.5v111.3c0,2.4-2,4.4-4.4,4.4h-123.8Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.8,589.6c0-5.5,4.5-10,10-10h112.6c5.5,0,10,4.5,10,10v21.2h-132.5v-21.2Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,742.8h118.2c.7,0,1.3-.6,1.3-1.3v-10h1.5c3.8,0,6.9-3.1,6.9-6.9v-135.1c0-6.9-5.6-12.5-12.5-12.5h-112.6c-6.9,0-12.5,5.6-12.5,12.5v135.1c0,3.8,3.1,6.9,6.9,6.9h1.5v10c0,.7.6,1.3,1.3,1.3ZM533.2,740.3v-8.7h115.7v8.7h-115.7ZM524.8,589.6c0-5.5,4.5-10,10-10h112.6c5.5,0,10,4.5,10,10v21.2h-132.5v-21.2ZM529.2,729c-2.4,0-4.4-2-4.4-4.4v-111.3h132.5v111.3c0,2.4-2,4.4-4.4,4.4h-123.8Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.5,588.7h-33.8c-.5,0-1,.4-1,1v11.3c0,.5.4,1,1,1h33.8c.5,0,1-.4,1-1v-11.3c0-.5-.4-1-1-1ZM567.6,599.9h-31.9v-9.4h31.9v9.4Z",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.4,588.5c-3.7,0-6.8,3-6.8,6.8s3,6.8,6.8,6.8,6.8-3,6.8-6.8c0-3.7-3-6.8-6.8-6.8ZM585.4,599.7h0c-1.2,0-2.3-.5-3.2-1.3-.8-.8-1.3-2-1.3-3.2,0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5-2,4.5-4.5,4.5Z",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.9,588.5c-3.7,0-6.8,3-6.8,6.8s3,6.8,6.8,6.8,6.8-3,6.8-6.8-3-6.8-6.8-6.8ZM608,599.7h0c-1.2,0-2.3-.5-3.2-1.3-.8-.8-1.3-2-1.3-3.2s.5-2.3,1.3-3.2c.8-.8,2-1.3,3.2-1.3,2.5,0,4.5,2,4.5,4.5,0,2.5-2,4.5-4.5,4.5Z",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.5,594.3h-5.6c-.5,0-1,.4-1,1s.4,1,1,1h5.6c.5,0,1-.4,1-1,0-.5-.4-1-1-1Z",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.3,594.3h-5.6c-.5,0-1,.4-1,1s.4,1,1,1h5.6c.5,0,1-.4,1-1,0-.5-.4-1-1-1Z",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.1,712.6c-22.8,0-41.4-18.5-41.4-41.4s18.5-41.4,41.4-41.4,41.4,18.5,41.4,41.4h0c0,22.8-18.5,41.3-41.4,41.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M591.1,706.2c-14.1,0-26.8-8.4-32.2-21.4,0,0,0,0,0,0,0,0,0-.2,0-.2h0c-7.3-17.9,1.2-38.3,19-45.7,4.2-1.7,8.7-2.6,13.3-2.6h.2c19.2,0,34.8,15.6,34.8,34.8s-.4,6.1-1.2,9h0c-4.1,15.4-17.9,26-33.7,26.1h0ZM583.1,680.8c-.2,0-.4,0-.5,0-6.5.3-13,1.5-19.2,3.6l-1.8.6.9,1.7c8.6,15.8,28.3,21.7,44.1,13.1,5.9-3.2,10.7-8.2,13.7-14.2l2.1-4.3-4.3,2.1c-4,2-8.3,3-12.8,3h-.2c-.2,0-.4,0-.6,0-3.9,0-7.8-1-11.2-2.9-3.1-1.8-6.7-2.8-10.3-2.8M583.2,678.5c3.9,0,7.8,1,11.2,2.9,3.1,1.8,6.7,2.7,10.3,2.7s.4,0,.5,0h0c4.3,0,8.6-1,12.5-3,1.3-.6,2.7-1.2,4.1-1.6l.9-.3.2-.9c3.9-17.5-7.1-34.9-24.6-38.8-2.3-.5-4.7-.8-7.1-.8h0c-18,0-32.5,14.5-32.6,32.5,0,3.4.5,6.9,1.6,10.1l.5,1.6,1.5-.5c6.6-2.3,13.5-3.6,20.5-3.8.1,0,.3,0,.5,0",
    style: {
      fill: "#e4a05d",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.9,193.1h-118c-2.2,0-4-1.8-4-4V5.5c0-2.2,1.8-4,4-4h118c2.2,0,4,1.8,4,4v183.6c0,2.2-1.8,4-4,4Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 193.1,
    width: 7.1,
    height: 9.7,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 193.1,
    width: 7.1,
    height: 9.7,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.8,
    y1: 62.4,
    x2: 398.9,
    y2: 62.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2,51.5h-2.6c-1.1,0-2-.9-2-2v-28.9c0-1.1.9-2,2-2h2.6c1.1,0,2,.9,2,2v28.9c0,1.1-.9,2-2,2Z",
    style: {
      fill: "#fff",
      stroke: "#e39f5c",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2,117.9h-2.6c-1.1,0-2-.9-2-2v-41.4c0-1.1.9-2,2-2h2.6c1.1,0,2,.9,2,2v41.4c0,1.1-.9,2-2,2Z",
    style: {
      fill: "#fff",
      stroke: "#e39f5c",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "overview-story4-inner"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.8,
    cy: 440.2,
    r: 189.4,
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.8,
    cy: 217.5,
    r: 11.9,
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.8,
    y1: 217.5,
    x2: 334.8,
    y2: 259.5,
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.6,
    cy: 569.3,
    r: 11.9,
    transform: "translate(-179.2 237.6) rotate(-22.5)",
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 507.6,
    y1: 569.3,
    x2: 475.1,
    y2: 542.8,
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.2,
    cy: 581.6,
    r: 11.9,
    style: {
      fill: "#e39f5c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.2,
    y1: 581.6,
    x2: 194.8,
    y2: 549,
    style: {
      fill: "none",
      stroke: "#e39f5c",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.9,
    y: 306.5,
    width: 166.9,
    height: 250.2,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 490.7,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 490.7,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 490.7,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 490.7,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 453.1,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 453.1,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 453.1,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 453.1,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 415.5,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 415.5,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 415.5,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 415.5,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 377.9,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 377.9,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 377.9,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 377.9,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.6,
    y: 340.3,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 340.3,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.1,
    y: 340.3,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 340.3,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.7,
    y: 523.3,
    width: 33.4,
    height: 33.4,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.1,490.3l-49.5-53.2c-.5-.5-1.4-.5-1.9,0l-49.5,53.2c-.8.8-.2,2.1.9,2.1h9.8v64.2h79.3v-64.2h9.8c1.1,0,1.7-1.3.9-2.1Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,527.6h-5.5c-3.4,0-6.1,2.7-6.1,6.1v23h17.8v-23c0-3.4-2.7-6.1-6.1-6.1Z",
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.5,
    y: 500.8,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.7,
    y: 500.8,
    width: 15.8,
    height: 15.8,
    style: {
      fill: "#b2c1bb",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewStory4);
export default __webpack_public_path__ + "static/media/overview-story4.198ed148.svg";
export { ForwardRef as ReactComponent };